import React from 'react';
import Icon from '../../../components/AppIcon';
import { buildBuckets } from '../../../utils/dateRangeHelpers';

const MomentumStrip = ({ events }) => {
  const buckets = buildBuckets('7d');
  const activeDateKeys = new Set((events || []).map((e) => e?.dateKey));
  const activeCount = buckets.filter((b) => activeDateKeys.has(b.key)).length;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Learning Momentum</p>
        <span className="text-xs text-muted-foreground">{activeCount}/7 days active</span>
      </div>
      <div className="flex gap-1.5">
        {buckets.map((b) => (
          <div
            key={b.key}
            className={`flex-1 h-2 rounded-full ${activeDateKeys.has(b.key) ? 'bg-accent' : 'bg-muted'}`}
            title={b.label}
          />
        ))}
      </div>
    </div>
  );
};

const SkillBar = ({ tag, avgScore }) => (
  <div className="mb-2.5">
    <div className="flex items-center justify-between mb-1">
      <span className="text-xs font-medium text-foreground">{tag}</span>
      <span className="text-xs text-muted-foreground">{avgScore}%</span>
    </div>
    <div className="h-1.5 bg-muted rounded-full overflow-hidden">
      <div className="h-full bg-accent rounded-full" style={{ width: `${avgScore}%` }} />
    </div>
  </div>
);

const LearningIntelligenceCard = ({ events, skills }) => {
  return (
    <div className="bg-white/60 backdrop-blur-xl border border-white/40 rounded-xl p-5 space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">Learning Intelligence</h3>
        <Icon name="Sparkles" size={14} className="text-accent" />
      </div>

      <MomentumStrip events={events} />

      <div>
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Skill Signals</p>
        {skills?.length > 0 ? (
          skills.slice(0, 4).map((s) => <SkillBar key={s.tag} tag={s.tag} avgScore={s.avgScore} />)
        ) : (
          <p className="text-xs text-muted-foreground">
            Skill signals appear once you complete tagged assessments.
          </p>
        )}
      </div>

      <div className="pt-1 border-t border-border/60">
        <div className="flex flex-wrap gap-2 pt-3">
          {['Knowledge gaps', 'Learning patterns', 'Readiness'].map((label) => (
            <div
              key={label}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-muted/60 border border-dashed border-border"
            >
              <Icon name="Clock" size={12} className="text-muted-foreground" />
              <span className="text-xs font-medium text-muted-foreground">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearningIntelligenceCard;